<div class="qa-pie-chart-options">
  <div class="chart-config-section mb-3">
    <label>{{_(KEYS.EDITOR.CHART_TITLE)}}:</label>
    <input
      class="form-control"
      type="text"
      [(ngModel)]="chartData.title[locale]"
    >
  </div>

  <div class="chart-config-row mb-3">
    <div class="chart-config-field">
      <label>{{_(KEYS.EDITOR.CHART_WIDTH)}}:</label>
      <input
        class="form-control width-input"
        type="number"
        min="1" max="100"
        [(ngModel)]="chartData.widthPercent"
      >
    </div>

    <div class="chart-config-field">
      <label>{{_(KEYS.EDITOR.CHART_ALIGNMENT)}}:</label>
      <select
        class="form-control"
        [(ngModel)]="chartData.alignment"
      >
        <option
          *ngFor="let opt of alignmentOptions"
          [value]="opt.value"
        >
          {{_(KEYS.EDITOR[opt.label])}}
        </option>
      </select>
    </div>
  </div>

  <div class="form-check mb-3">
    <input
      class="form-check-input"
      type="checkbox"
      id="sortByValue"
      [(ngModel)]="chartData.sortByValue"
    >
    <label
      class="form-check-label"
      for="sortByValue"
    >
      {{_(KEYS.EDITOR.SORT_BY_VALUE)}}
    </label>
  </div>

  <div><strong>{{_(KEYS.EDITOR.ENTRIES)}}:</strong></div>
  <div
    *ngFor="let entry of chartData.entries;
      let position = index;"
    class="entries"
  >
    <div class="input-group mb-1">
      <button
        class="btn btn-success qa-input-position mr-1"
      >
        {{position + 1}}
      </button>

      <div class="btn-group ml-1 mr-2">
        <button
          class="btn btn-primary"
          (click)="onPositionChange(
            position, position - 1
          )"
        >
          <i class="fa fa-arrow-up"></i>
        </button>

        <button
          class="btn btn-primary"
          (click)="onPositionChange(
            position, position + 1
          )"
        >
          <i class="fa fa-arrow-down"></i>
        </button>
      </div>

      <input
        type="text"
        class="form-control entry-label"
        [(ngModel)]="entry.label[locale]"
        [placeholder]="_(KEYS.EDITOR.ENTRY_LABEL)"
      >

      <app-select2
        cmpCssClasses="select-fix ml-2 entry-variable"
        [options]="select2Opts"
        [(selected)]="entry.variable"
        [hideButton]="true"
        [hideLabel]="true"
      >
        <option *ngFor="let variable of variables">
          {{variable}}
        </option>
      </app-select2>

      <input
        type="color"
        class="form-control entry-color ml-2"
        [(ngModel)]="entry.color"
        [title]="_(KEYS.EDITOR.ENTRY_COLOR)"
      >

      <button
        class="btn btn-danger ml-2"
        (click)="onDeleteEntry(position)"
      >
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>

  <div class="btn-group mt-2">
    <button
      class="btn btn-sm btn-success"
      (click)="onAddEntry()"
    >
      <i class="fa fa-plus"></i>
      {{_(KEYS.EDITOR.ADD_ENTRY)}}
    </button>
  </div>
</div>
